import React from 'react';

const AdminHeader = (props) => {
    return (
        <div className={""}>
            <div className="header__text" style={{
                // 'background': props.BgColor !== undefined ? props.BgColor : '#fff' ,
                // 'text-align': 'center',
                // 'padding': '20px',
                // 'border-radius':' 5px',
            }}>
                <span className="badge" style={{"backgroundColor":props.BgColor}}>{props.children}</span>
            </div>
        </div>
    );
};

export default AdminHeader;
